import type { ProductModel } from './products.types';
import type { TechnicalSupportProviderModel } from './technical-support-providers.types';
import type { UserModel } from './users.types';

export enum BrewerStatusType {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  ARCHIVED = 'ARCHIVED'
}

export interface BrewerModel {
  id: string;
  name: string;
  amsAgreement: boolean;
  status: BrewerStatusType;
  user: UserModel | null;
  products: ProductModel[];
  technicalSupportProvider: TechnicalSupportProviderModel | null;
  maxFixes?: number;
}

export interface ListBrewersResponse {
  result: ListBrewerModel[];
  limit: number;
  offset: number;
  count: number;
}

export interface ListAutoCompleteBrewersResponse {
  result: BrewerModel[];
  count: number;
}

export interface CreateBrewerParams {
  name: string;
  amsAgreement: boolean;
  status: BrewerStatusType;
  userId?: string;
  maxFixes?: number;
}

export interface UpdateBrewerParams extends CreateBrewerParams {}

export interface UpdateBrewerParamsWithId extends UpdateBrewerParams {
  brewerId: string;
}

export interface DeleteBrewerParams {
  brewerId: string;
}

export interface BrewerFilterProps {
  name?: string;
  status?: BrewerStatusType;
  amsAgreement?: boolean;
  maxFixes?: number;
  product?: ProductModel;
  user?: UserModel;
}

export type BrewerSortingFields = 'name' | 'status' | 'amsAgreement' | 'maxFixes' | 'productsCount' | 'contactName';

export type ListBrewerModel = Pick<BrewerModel, 'id' | 'name' | 'status' | 'amsAgreement' | 'maxFixes' | 'user'> & {
  productsCount: number;
};
